import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine2Body1SecondaryProps extends ITextBoxProps {}

export const TextBoxMaxLine2Body1Secondary = ({
  title,
  color = Colors.TEXT_ICON_SECONDARY,
  font = TextBoxTypes.Body1,
  alignment = TextAligning.Left,
  maxLines = 2,
  ...rest
}: ITextBoxMaxLine2Body1SecondaryProps): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    maxLines={maxLines}
    {...rest}
  />
)
